import { render, staticRenderFns } from "./WishListInactiveItem.vue?vue&type=template&id=5edff1eb&"
import script from "./WishListInactiveItem.vue?vue&type=script&lang=js&"
export * from "./WishListInactiveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edff1eb')) {
      api.createRecord('5edff1eb', component.options)
    } else {
      api.reload('5edff1eb', component.options)
    }
    module.hot.accept("./WishListInactiveItem.vue?vue&type=template&id=5edff1eb&", function () {
      api.rerender('5edff1eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/wishList/WishListInactiveItem.vue"
export default component.exports